import {
    FileCheck2,
    Receipt,
    BadgeCheck,
    Calculator,
    ScrollText,
    Scale,
    TrendingDown,
} from "lucide-react";

export const checklists = [
    {
        id: "year-end-tax",
        title: "Annual Year-End Tax Checklist",
        category: "Year-End Pack",
        type: "printable",
        href: "/checklists/year-end-tax",
        downloadHref: "/checklists/year-end-tax",
        icon: ScrollText,
        time: "Print as PDF",
        blurb:
            "The complete prep list TC Auditors uses for every client year-end — bank, debtors, creditors, payroll, fixed assets, tax-saving prompts and SARS deadlines. Branded, printable, ready to file.",
        cta: "Open & Print",
    },
    {
        id: "vat-invoice",
        title: "SARS VAT Tax Invoice Checklist",
        category: "VAT Compliance",
        type: "interactive",
        href: "/checklists/vat-invoice",
        icon: Receipt,
        time: "± 1 min · email or download",
        blurb:
            "Every requirement of a valid SARS Tax Invoice (Section 20 of the VAT Act). Email it to yourself or download the official PDF — pin it next to your invoice template to avoid disallowed input VAT.",
        cta: "Open & email",
    },
    {
        id: "sbc-qualifier",
        title: "Small Business Corporation (SBC) Qualifier",
        category: "Income Tax",
        type: "interactive",
        href: "/checklists/sbc-qualifier",
        icon: BadgeCheck,
        time: "± 3 min",
        blurb:
            "Six precise questions test the s.12E criteria — entity type, shareholder profile, investment-income limit, personal-service exclusion and gross-income cap. Get an instant Yes / No / Maybe.",
        cta: "Start Questionnaire",
    },
    {
        id: "provisional-tax",
        title: "Provisional Taxpayer Status Check",
        category: "Income Tax",
        type: "interactive",
        href: "/checklists/provisional-tax",
        icon: FileCheck2,
        time: "± 2 min",
        blurb:
            "Are you required to register as a provisional taxpayer? This walks you through the para 1 Fourth Schedule definition and the practical exclusions (pensioners, salary-only earners, etc.).",
        cta: "Start Questionnaire",
    },
    {
        id: "pis-calculator",
        title: "Audit vs Independent Review (PIS) Calculator",
        category: "Companies Act",
        type: "interactive",
        href: "/checklists/pis-calculator",
        icon: Calculator,
        time: "± 1 min",
        blurb:
            "Enter four numbers — average employees, third-party debt, turnover and shareholders — and we compute your Companies Regulation 26 Public Interest Score and the assurance level required.",
        cta: "Calculate PIS",
    },
    {
        id: "vat-registration",
        title: "Should You Register for VAT?",
        category: "VAT Compliance",
        type: "interactive",
        href: "/checklists/vat-registration",
        icon: Scale,
        time: "± 2 min",
        blurb:
            "Compulsory or voluntary registration? Net-positive or net-negative for cash flow? A short questionnaire that gives you a clear, honest recommendation in plain English.",
        cta: "Start Questionnaire",
    },
    {
        id: "ring-fencing",
        title: "Assessed Losses: Ring-Fencing for Sideline Businesses",
        category: "Income Tax",
        type: "interactive",
        href: "/checklists/ring-fencing",
        icon: TrendingDown,
        time: "± 3 min",
        blurb:
            "Running a side hustle that's making a loss? Section 20A of the Income Tax Act may stop you deducting it from your salary. Answer a few plain-English questions — including the tighter rules from 1 March 2026 — and find out where you stand.",
        cta: "Start Questionnaire",
    },
];
